export default {
  title1: 'successful',
  title2: ['application', ''],
  msg: ['You will soon receive an application ', 'confirmation in your email!'],

  buttonContent: 'COME BACK',
}
